/** Wrap user-created text according to measured pixel/point width.
 * No dependency on Canvas or PDF for unit testing. */
export function wrapTextLines(input, maxWidth, measure) {
  if (!Number.isFinite(maxWidth) || maxWidth <= 0) return [''];
  const lines = [];
  for (const paragraph of String(input ?? '').replace(/\r\n?/g, '\n').split('\n')) {
    if (!paragraph) { lines.push(''); continue; }
    let current = '';
    const words = paragraph.match(/\S+|\s+/g) || [];
    for (const token of words) {
      if (measure(current + token) <= maxWidth) {
        current += token;
        continue;
      }
      if (current.trim()) { lines.push(current.trimEnd()); current = ''; }
      const leading = token.trimStart();
      if (!leading) continue;
      if (measure(leading) <= maxWidth) { current = leading; continue; }
      for (const char of leading) {
        if (current && measure(current + char) > maxWidth) {
          lines.push(current);
          current = '';
        }
        current += char;
      }
    }
    lines.push(current.trimEnd());
  }
  return lines;
}
